import { render, staticRenderFns } from "./chooseGoodsDialog.vue?vue&type=template&id=0161d4dc&scoped=true"
import script from "./chooseGoodsDialog.vue?vue&type=script&lang=js"
export * from "./chooseGoodsDialog.vue?vue&type=script&lang=js"
import style0 from "./chooseGoodsDialog.vue?vue&type=style&index=0&id=0161d4dc&prod&lang=scss&scoped=true"
import style1 from "./chooseGoodsDialog.vue?vue&type=style&index=1&id=0161d4dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0161d4dc",
  null
  
)

export default component.exports